import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SummaryReportModel } from './summary-report.model';

export class SummaryReportResponse extends GlobalResponseObject {
    data?: SummaryReportModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SummaryReportModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}